import { createFileRoute } from "@tanstack/react-router";
import { lazy, Suspense } from "react";

const InvoiceGateQueuePage = lazy(() => import("@/features/invoice-gate/pages/invoice-gate-queue"));

export const Route = createFileRoute("/(app)/dashboard/invoice-gate/")({
  component: () => (
    <Suspense fallback={<div className="text-muted-foreground text-sm">Loading Invoice Gate...</div>}>
      <InvoiceGateQueuePage />
    </Suspense>
  ),
});
